import { Box, Button, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Color,
  EduPostTypes,
  FontStyle,
  JobDisplays,
  Slug,
  SurveyButtonStyle,
} from "../../constants";
import {
  DownloadTemplateWrapper,
  jobButtonStyle,
  JobDownloads,
  JobFontSize,
  TaggedRow,
} from "../../utils/jobUtils";
import { BlurSpan } from "../../utils/spanUtils";
import { ResourceHeader } from "../JobPanels/ResourcePanel";
import EduAvatar, { authorMap } from "./EduAvatar";
import { eduId_urlId } from "../../utils/eduUtils";

const styles = {
  sectionBody: {
    ...FontStyle.body,
    fontSize: JobFontSize.medium,
  },
  sectionBodyFullSize: {
    ...FontStyle.body,
    fontSize: { xs: "16px", md: "18px" },
    lineHeight: { xs: 1.5, md: 1.4 },
  },
};

export const FullBody = ({ description, fullSize = false, blurIdx = null }) => {
  return (
    <Box
      sx={{
        ...styles.sectionBody,
        ...(fullSize && styles.sectionBodyFullSize),
      }}>
      {description.map((row, i) => {
        return blurIdx !== null && i >= blurIdx ? (
          <BlurSpan key={i}>
            <TaggedRow row={row} blur />
          </BlurSpan>
        ) : (
          <TaggedRow row={row} key={i} />
        );
      })}
    </Box>
  );
};
const FullTextPanel = ({ data, setIdx }) => {
  const auth = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const loggedIn =
    auth.accountData.loginToken !== null &&
    auth.accountData.contactInfo !== null;
  const {
    title,
    subtitle,
    description,
    tags,
    lastElement,
    showIdx,
    author,
    download_name,
    eduId,
  } = data;
  // console.log("data", data);
  return (
    <Box
      sx={{
        // outer container, restricted to 90vh
        // centered on screen because container is stack
        position: "relative",
        maxHeight: { xs: "100vh", md: "90vh" },
      }}>
      <Stack
        spacing={2}
        direction="column"
        onClick={(e) => e.stopPropagation()}
        sx={{
          // inner container, scrollable
          // has a padding bottom so that white panel can be
          // scrolled to have some empty space beneath
          // padding: { xs: 0, md: "32px" },
          paddingTop: { xs: 0, md: "32px" },
          px: { xs: 0, md: "32px" },
          paddingBottom: { xs: "64px", md: "32px" }, // more padding on bottom so mobile can see past their own bottom bar
          width: "100%",
          maxWidth: "800px",
          overflow: "scroll",
          // maxHeight: "100%",
          position: "relative",
        }}>
        <Stack
          spacing={2}
          direction="column"
          sx={{
            // white container
            borderRadius: JobDisplays.borderRadius,
            padding: { xs: JobDisplays.padding, md: "32px" },
            backgroundColor: JobDisplays.backgroundColor,
            boxShadow: JobDisplays.boxShadow,
          }}>
          <EduAvatar idx={authorMap[author] ? authorMap[author] : 0} />
          <ResourceHeader title={title} subtitle={subtitle} fullSize />
          <FullBody
            description={description}
            fullSize
            blurIdx={loggedIn ? null : showIdx ? showIdx - 1 : 1}
          />
          {download_name &&
            JobDownloads[download_name] !== undefined &&
            !loggedIn && (
              <Box
                sx={{
                  ...jobButtonStyle,
                  width: "100%",
                  maxWidth: "100%",
                  backgroundSize: "300% 100%",
                  transition: "all 0.25s ease-in-out",
                  backgroundColor: "#fff",
                  backgroundImage:
                    "linear-gradient(to right, rgba(250, 250, 150,0.5), #6dd5ed90, #6dd5ed90, rgba(250, 250, 150,0.5))",
                  "&:hover": {
                    // backgroundColor: "transparent",
                    backgroundPosition: "right",
                    // border: `2px solid ${Color.bgDark}`,
                    // boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
                  },
                  ...(!loggedIn && {
                    filter: "blur(2px)",
                    cursor: "not-allowed",
                    "&:hover": {},
                    "&:active": {},
                  }),
                }}>
                {loggedIn ? (
                  <DownloadTemplateWrapper
                    href={JobDownloads[download_name].url}>
                    {JobDownloads[download_name].name}
                  </DownloadTemplateWrapper>
                ) : (
                  <BlurSpan>{JobDownloads[download_name].name}</BlurSpan>
                )}
              </Box>
            )}
          {download_name &&
            JobDownloads[download_name] !== undefined &&
            loggedIn && (
              <DownloadTemplateWrapper href={JobDownloads[download_name].url}>
                <Box
                  sx={{
                    ...jobButtonStyle,
                    width: "100%",
                    maxWidth: "100%",
                    backgroundSize: "300% 100%",
                    transition: "all 0.25s ease-in-out",
                    backgroundColor: "#fff",
                    backgroundImage:
                      "linear-gradient(to right, rgba(250, 250, 150,0.5), #6dd5ed90, #6dd5ed90, rgba(250, 250, 150,0.5))",
                    "&:hover": {
                      // backgroundColor: "transparent",
                      backgroundPosition: "right",
                      // border: `2px solid ${Color.bgDark}`,
                      // boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.15)",
                    },
                    ...(!loggedIn && {
                      filter: "blur(2px)",
                      cursor: "not-allowed",
                      "&:hover": {},
                      "&:active": {},
                    }),
                  }}>
                  {JobDownloads[download_name].name}
                </Box>
              </DownloadTemplateWrapper>
            )}
        </Stack>
        {!loggedIn && (
          <Stack
            direction="column"
            alignItems="center"
            justifyContent="center"
            onClick={(e) => e.stopPropagation()}
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width: "100%",
              transform: "translate(-50%, -50%)",
              // background: "rgba(0, 0, 0, 0.2)",
              // px: 3,
              // background: "rgba(255, 255, 255)",
              zIndex: 1,
            }}>
            <Box
              onClick={() => {
                navigate({
                  pathname: Slug.signUp + "/",
                  search: `?post=${eduId_urlId(eduId)}`,
                });
              }}
              sx={{
                ...jobButtonStyle,
                px: 4,
                py: 4,
                fontSize: "18px",
                overflow: "hidden",
              }}>
              {/* View full document */}
              {download_name && JobDownloads[download_name] !== undefined
                ? JobDownloads[download_name].name
                : "View full document"}
            </Box>
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default FullTextPanel;
